export const responseMensagemStatus: any = {
  'The suggested Bank already exists': 'O banco sugerido já existe.',
};
